import React from 'react';
import '../../App.css';

const Notifications = () => {
  // Inline styles for the notification dot
  return (<div>UNDER CONSTRUCTION</div>)
  const dotStyle = {
    width: '7px',
    height: '7px',
    background: 'var(--fd-red)',
    borderRadius: '50%',
    marginLeft: 'auto',
    flexShrink: 0,
  };

  return <div style={dotStyle} />;
};

export default Notifications;
